import { Grid, TextField, Typography, MenuItem, FormControlLabel, Checkbox, Tooltip, InputAdornment, Popper } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm, } from "react-hook-form";
import React, { useState, useEffect, Fragment } from 'react';
import { constructIds, fieldDimensionOptions, hyperlinkOptions, hyperlinkTypes } from '../../../config/common';
import { validationMessages, basicFolderFileName, numberOnlyMessage, requiredOnly, requiredOnlyMessage, patternOnly, patternOnlyMessage, typeSpecificValidation, integerFloatCheck, variableBasic } from '../../../config/validations';
import { typeItems, defaultValueTypes, minValueTypes, maxValueTypes, unitTypes, dropdownTypes, dimensionTypes, axisTypes, validationTypes, minValueTypesForEventType, maxValueTypesForEventType, typesForFieldsWithParentChartType, visibleTypes, controlTypes, otherDisplayTypes, hyperlinkSupportedTypes, urlTypes, typesForFieldsWithParentMapType, axisTypesForMap, urlItems, iconTypes, orientationTypes, hyperlinkNotRequiredType, mediaTypes } from '../../../config/fields';
import { booleanOptions, axisOptions, orientationOptions, lineTypeOptions } from '../../../config/common';
import { createDefaultNestedFieldsForChartBarLine, createDefaultNestedFieldsForChartGeomap, createDefaultNestedFieldsForChartPie, formatDateTime, createDefaultNestedFieldsForVideo, createNestedFieldsForControls, createDefaultNestedFieldsForImage, createDefaultNestedFieldsForURLExternal, createDefaultNestedFieldsForURLClusterlet, createDefaultNestedFieldsForURLView, createDefaultNestedFieldsForModel3D, createDefaultNestedFieldsForScene3D, createDefaultNestedFieldsForCompass, createDefaultNestedFieldsForChartPieRadial, createDefaultNestedFieldsForHeatmap, createDefaultNestedFieldsForRangePlot, createDefaultNestedFieldsForStackBarChart, createDefaultNestedFieldsForRatioBarChart, createDefaultNesterFieldsForGauge, findMessageTypes } from '../../../services/entities/fields';
import CreateCancel from "../../atoms/buttons/CreateCancel";
import DateTimePickerField from "../../atoms/Wrappers/dateTimePicker";
import ListSubheader from '@material-ui/core/ListSubheader';
import { findSelectedSchema } from "../../../services/builder/util";
import { invokeGetService, invokePostService, setInnerScreenRender, setLatestFieldAdded, setExpanded, setReRender } from '../../../store/global/actions'
import { getFirstOrderEvents } from "../../../services/blueprint";
import { getElementOnFocus, getTabOnFocus } from '../../../store/global/selectors';
import { Autocomplete } from '@material-ui/lab';
import { validateNonAsciiChars } from '../../../utils/commonUtils';

const shortUUiD = require("short-uuid");

export default function CreateField(props) {
    const { onClose, onCompletion, section, parentDT, isEventType, messageId, event } = props;
    const dispatch = useDispatch();

    const elementOnFocus = useSelector(getElementOnFocus);


    const [sectionList, setSectionList] = useState([]);
    const [fieldList, setFieldList] = useState([]);
    const [messageList, setMessageList] = useState([]);
    const [clusterletlist, setClusterletlist] = useState([]);
    const [allEvents, setAllEvents] = useState([]);
    const [expandForm, setExpandForm] = useState(false);
    const [rootElement, setRootElement] = useState(null);
    const [defaultDate, setDefaultDate] = useState(null);
    const [displayTypes, setDisplayTypes] = useState([]);
    const [filteredTypeItems, setFilteredTypeItems] = useState([]);
    const [dateStatus, setDateStatus] = useState(true);
    const [fieldParent, setFieldParent] = useState(null);
    const tabOnFocus = useSelector(getTabOnFocus);
    const [profile, setProfile] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isOptional, setOptional] = useState(false)
    const [transactions, setTransactions] = useState([]);
    const [nestedTransactions, setNestedTransactions] = useState([]);
    const [delegates, setDelegates] = useState([]);
    const [messageTypes, setMessageTypes] = useState([]);
    const [viewsNames, setViewsNames] = useState([]);
    const [clusterletNames, setClusterletNames] = useState([]);
    const [bgcolor, setBgcolor] = useState("#ffffff");
    const [textcolor, setTextcolor] = useState("#34495e");

    let root = "";

    const typesNotInEventType = ['counter', 'gauge', 'chart-geomap', 'chart-bar', 'chart-line', 'TimeStamp', 'DateTime', 'video', 'display', 'url-external', 'url-clusterlet', 'url-view', 'table', 'model-3d', 'table-button'];

    const selectedNode = fieldList.find(item => item._id === section.id) ? fieldList.find(item => item._id === section.id) : messageList.find(item => item._id === section.id) ? messageList.find(item => item._id === section.id) : sectionList.find(item => item._id === section.id)
    const typeIntItems = ['UINT8', 'UINT16', 'UINT32', 'UINT64', 'INT8', 'INT16', 'INT32', 'INT64', 'DOUBLE', 'FLOAT', 'counter', 'double'];


    const typeDateItems = ['DateTime', 'TimeStamp'];
    const numberTypes = ['gauge', 'FLOAT', 'DOUBLE', 'double'];
    const stringTypes = ['OCTETSTRING', 'string'];
    // const directParent = section.item === 'field' ? fieldList.find(item => item.id === section.id) : sectionList.find(item => item.id === section.id)

    const { register, handleSubmit, formState: { errors }, control, setFocus, watch, setValue, getValue, reset, setError } = useForm();;
    const findRootElement = (section, clusterletsArray, sectionsArray, messagesArray, fieldsArray) => {

        const element = fieldsArray.find(item => item._id === section.id) ? fieldsArray.find(item => item._id === section.id)
            : messagesArray.find(item => item._id == section.id) ? messagesArray.find(item => item._id === section.id)
                : sectionsArray.find(item => item._id === section.id)

        if (section.item === 'field') {
            if (element?.type === 17) {
                setRootElement('eventType');
                setFieldParent(element)
                const filteredMessages = messagesArray.filter(item => item._id != element._id);
                setMessageTypes(findMessageTypes(filteredMessages, fieldsArray));
            }
            else if (element?.type === 11) {
                setRootElement('property');
                setFieldParent(element)
            }
            else {
                const parent = JSON.parse(JSON.stringify(element?.parent))

                parent[0].item = 'field';
                findRootElement(parent[0], clusterletsArray, sectionsArray, messagesArray, fieldsArray)
            }
        }
        if (section?.item === 'section') {
            setRootElement('property')
        }

        if (section?.item === 'message') {
            setRootElement('eventType')
            const filteredMessages = messagesArray.filter(item => item._id != element._id);
            setMessageTypes(findMessageTypes(filteredMessages, fieldsArray));
            setFieldParent(element)

        }

        if (element?.type === 11) {
            const type = clusterletsArray.find(item => item._id === element?.parent[0].id).type
            if (type === 6) setProfile(true)
        }

    }
   
    useEffect(() => {
        dispatch(invokeGetService('getBlueprintConstructs', [])).then(res => {
            if (res?.status) {
                const filteredTransactions = res?.data?.transactions ? res?.data?.transactions.filter(tr => tr.type == 7) : [];
                const sectionsArray = res?.data?.sections ? res?.data?.sections : [];
                const eventsArray = res?.data?.events ? res?.data?.events : [];
                const clusterletsArray = res?.data?.clusterlets ? res?.data?.clusterlets : [];
                const messagesArray = res?.data?.messages ? res?.data?.messages : [];
                const fieldsArray = res?.data?.fields ? res?.data?.fields : [];
                const firstOrderEvents = getFirstOrderEvents(eventsArray, clusterletsArray);
                const viewNames = res?.data?.views ? res?.data?.views : [];
                const clusterletNames = res?.data?.clusterlets ? res?.data?.clusterlets.filter(item => item.type == 2 || item.type == 3) : [];
                findRootElement(section, clusterletsArray, sectionsArray, messagesArray, fieldsArray);
                setTransactions(filteredTransactions);
                setNestedTransactions(res?.data?.transactions ? res?.data?.transactions.filter(tr => !(tr.type == 7)) : [])
                setViewsNames(viewNames);
                setClusterletNames(clusterletNames);
                setSectionList(sectionsArray);
                setClusterletlist(clusterletsArray);
                setMessageList(messagesArray);
                setFieldList(fieldsArray);
                setAllEvents(res?.data?.events ? res?.data?.events : []);
                setDelegates(res?.data?.clusterlets ? res?.data?.clusterlets.filter(item => item.type == 1) : []);
            } else {
                if (res?.code === 255) {
                    onClose();
                }
            }
        });
    }, []);




    useEffect(() => {
        if (rootElement) {
            if (rootElement === 'eventType') {
                const filteredTypes = typeItems.filter(item => !typesNotInEventType.includes(item.value));
                const sortedTypes = [...filteredTypes, ...mediaTypes].sort((a, b) => a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1);
                setFilteredTypeItems(sortedTypes);
            } else if (selectedNode?.attributes?.type === 'chart-rangeplot' || selectedNode?.attributes?.type === "chart-geomap") {
                setFilteredTypeItems(typeItems)
            } else {

                if (axisTypes.includes(selectedNode?.attributes?.type)) setFilteredTypeItems(typeItems.filter(item => typesForFieldsWithParentChartType.includes(item.value)))

                else if (axisTypesForMap.includes(selectedNode?.attributes?.type)) setFilteredTypeItems(typeItems.filter(item => typesForFieldsWithParentMapType.includes(item.value)))

                else {
                    setFilteredTypeItems(parentDT ? typeItems : typeItems.filter(item => item.value !== "table-button"));

                }
            }
        }

        if (selectedNode?.attributes?.type === 'table') {
            setDisplayTypes([...urlItems])
        }
        else {
            setDisplayTypes([...otherDisplayTypes.filter((item) => item.title !== "Table"), ...urlItems])
        }

    }, [section, fieldList, rootElement]);

    useEffect(() => {
        if (selectedNode?.attributes?.type === 'table') {
            setDisplayTypes([...urlItems])
        } else {
            setDisplayTypes([...otherDisplayTypes.filter((item) => item.title !== "Table"), ...urlItems])
        }
    }, [selectedNode]);


    const type = watch('type')
    const height = watch('height')
    const width = watch('width')
    const hyperlinkOption = watch('hyperlink')
    const selectedHyperlinkType = watch('hyperlinkType')
    const selectedTransaction = watch('transaction')

    useEffect(() => {
        if (typeIntItems.includes(type)) setValue('defaultVal', 0)
        if (stringTypes.includes(type)) setValue('defaultVal', '')

    }, [type]);

    const constraintNotSupportedType = ["struct", ...messageTypes?.map(item => item?._id)];
    const colorSupportedTypes = ["counter", "string"]
    const multilineInputSupportedTypes = ["string", "OCTETSTRING"]

    const renderDefaultValue = (defaultValueTypes.includes(type));
    const renderMinValue = (minValueTypes.includes(type)) && rootElement === 'property' || (minValueTypesForEventType.includes(type)) && rootElement === 'eventType' ? true : false;
    const renderMaxValue = (maxValueTypes.includes(type)) && rootElement === 'property' || (maxValueTypesForEventType.includes(type)) && rootElement === 'eventType' ? true : false;
    const renderUnitValue = (unitTypes.includes(type)) && rootElement === 'property' ? true : false;
    const renderdropdownValue = (dropdownTypes.includes(type)) && rootElement === 'property' && profile === true ? true : false;
    const renderCollectionValue = type && rootElement === 'eventType' ? true : false;
    const renderaxisValue = selectedNode?.type === 12 && (axisTypes.includes(selectedNode?.attributes?.type)) ? true : false;
    const renderValidationValue = (validationTypes.includes(type)) && rootElement === 'eventType-update-when-validation-needed' ? true : false;
    const renderDatePicker = (typeDateItems.includes(type)) ? true : false;
    const renderBooleanDefaultValue = (type === 'BOOL') ? true : false;
    const renderVisibilityValue = (visibleTypes.includes(type)) && parentDT === true /*|| urlTypes.includes(type) && directParent.type !== 'table' */ || selectedNode?.attributes?.type === 'table' ? true : false;
    const renderOptionalValue = rootElement === 'eventType' ? true : false;
    const renderDisplayTypes = dimensionTypes.includes(type) && parentDT === true ? true : false;
    const renderControlTypes = controlTypes.includes(type) && parentDT === true ? true : false;
    const renderOrientation = orientationTypes.includes(type);
    const renderlineType = type === 'chart-line' ? true : false;
    const disableDisplayOptions = rootElement === 'eventType' ? false : true;
    const renderStep = type === 'control-slider' ? true : false;
    const renderIconType = type === 'counter' ? true : false;
    const renderContraint = rootElement === 'eventType' && !constraintNotSupportedType?.includes(type) ? true : false;
    const renderMultilineInputCheckbox = profile === true && multilineInputSupportedTypes.includes(type);

    

    const parentOfSelectedNode = fieldList.find(field => field._id == selectedNode?.parent?.[0]?.id);
    const isParentTable = selectedNode?.attributes?.type === 'table' ? true : false;
    const isHyperlinkRequired = hyperlinkNotRequiredType.includes(type) ? false : true; 
    const renderHyperlink = ( !urlTypes.includes(type) && isParentTable && !(parentOfSelectedNode?.attributes?.type === "table") && isHyperlinkRequired) || hyperlinkSupportedTypes.includes(type);

    const renderColorForString = !isParentTable ? true : false;
    const renderColorPicker = profile === false && colorSupportedTypes?.includes(type) && renderColorForString && !isEventType ? true : false;
    

    const getElementId = (type) => {
        let id = '';
        constructIds.forEach(construct => {
            if (construct.type === type) id = construct.id;
        });
        return id;
    }


    const toggleExpandForm = () => {
        setExpandForm(prev => !prev)
    }

    const handleChange = (value) => {
        value == 'Invalid Date' ? setDateStatus(false) : setDateStatus(true);
        const formattedDate = (value !== null) ? formatDateTime(value) : null;
        setDefaultDate(formattedDate);
        setValue('defaultVal', formattedDate);

    }

    const onCreate = (data) => {
        setLoading(true);
        const { name, description, type, collection, dropdown, target, optional, maxvalue, minvalue, unit, axis, dimensions, defaultVal, validation, height, width, visible, event, orientation, defaultBoolVal, step, linetype, iconType, hyperlink, hyperlinkType, viewname, clusterlettype, instance, url, transaction, constraint, allowMultiline } = data || {};
        const fieldDataFormat = {
            name: name,
            attributes: {},
            id: shortUUiD.generate(),
            type: getElementId('field'),
            parent: [
                {
                    id: section.id,
                    type: section.item,
                }
            ],
        }


        // removed the default visible option for fields of table as the user can specify it from UI now
        const parentData = findSelectedSchema({ schemas: fieldList, id: section.id });
        // if (parentData?.attributes?.type === 'table') fieldDataFormat.attributes.visible = true;

        if (description !== '' && description !== undefined) fieldDataFormat.attributes.desc = description;
        if (type !== '' && type !== undefined && type != 'display') fieldDataFormat.attributes.type = type;
        if (collection !== '' && collection !== undefined) fieldDataFormat.attributes.collection = collection;
        if (dropdown !== '' && dropdown !== undefined) fieldDataFormat.attributes.dropdown = dropdown;
        if (optional !== '' && optional !== undefined) fieldDataFormat.attributes.optional = optional;
        if (maxvalue !== '' && maxvalue !== undefined) fieldDataFormat.attributes.maxval = maxvalue;
        if (minvalue !== '' && minvalue !== undefined) fieldDataFormat.attributes.minval = minvalue;
        if (unit !== '' && unit !== undefined) fieldDataFormat.attributes.unit = unit;
        if (axis !== '' && axis !== undefined) fieldDataFormat.attributes.axis = axis;
        if (defaultVal !== '' && defaultVal !== undefined && type !== 'BOOL') fieldDataFormat.attributes.default = defaultVal;
        if (defaultBoolVal !== undefined && type === 'BOOL') fieldDataFormat.attributes.default = defaultBoolVal;
        if (validation !== '' && validation !== undefined) fieldDataFormat.attributes.validation = validation;
        if (visible !== '' && visible !== undefined) fieldDataFormat.attributes.visible = visible;
        if (typeDateItems.includes(type) && defaultDate !== undefined) fieldDataFormat.attributes.default = defaultDate;
        if (orientation !== undefined && orientation !== '') fieldDataFormat.attributes.orientation = orientation;
        if (step !== undefined && step !== '' && step !== 0) fieldDataFormat.attributes.step = step;
        if (linetype !== undefined && linetype !== '') fieldDataFormat.attributes.linetype = linetype;
        if (iconType !== undefined && iconType !== '') fieldDataFormat.attributes.icon = iconType;
        if (allowMultiline === true) fieldDataFormat.attributes.inputtype = "textarea";

        // control UI types
        if (controlTypes.includes(type)) {
            if (transaction !== undefined && transaction !== "") fieldDataFormat.attributes.transaction = transaction;
            if (instance !== undefined && instance !== "") fieldDataFormat.attributes.instance = instance;
        }

        /**by default */
        if (type === 'struct' && rootElement === 'property') fieldDataFormat.attributes.collection = false;

        if (type === 'table' && rootElement === 'property') fieldDataFormat.attributes.collection = true;

        if (type === 'counter') fieldDataFormat.attributes.infotype = "numeric";

        if (type === 'model-3d') {
            fieldDataFormat.attributes.infotype = 'numeric';
            fieldDataFormat.attributes.position = '+0+0';
        }

        if(!constraintNotSupportedType.includes(type) && constraint !== undefined){
            fieldDataFormat.attributes.constraint = constraint;
        }

        if(colorSupportedTypes.includes(type) && renderColorPicker && bgcolor && textcolor ){
            fieldDataFormat.attributes.bgcolor = bgcolor;
            fieldDataFormat.attributes.textcolor = textcolor;
        }


        //dimensions
        if (height !== '' && height !== undefined && width !== '' && width !== undefined) {
            fieldDataFormat.attributes.dimensions = `${width}x${height}`
        }

        let defaultNestedFields = []
        let associatedData = {}
        /**nested fields for types of chart */
        if (type === 'chart-bar' || type === 'chart-line' || type === 'chart-scatter') {
            defaultNestedFields = createDefaultNestedFieldsForChartBarLine(fieldDataFormat)
        }

        if (type === 'chart-geomap') {
            defaultNestedFields = createDefaultNestedFieldsForChartGeomap(fieldDataFormat)
        }

        if (type === 'chart-pie') {
            defaultNestedFields = createDefaultNestedFieldsForChartPie(fieldDataFormat)
        }

        /**nested fields for type video */
        if ( rootElement !== 'eventType' && type === 'video') {
            defaultNestedFields = createDefaultNestedFieldsForVideo(fieldDataFormat)
        }

        if (controlTypes.includes(type)) {
            defaultNestedFields = createNestedFieldsForControls(fieldDataFormat)
        }

        if ( rootElement !== 'eventType' && type === 'image') {
            defaultNestedFields = createDefaultNestedFieldsForImage(fieldDataFormat)
        }

        if (type === 'url-external') {
            defaultNestedFields = createDefaultNestedFieldsForURLExternal(fieldDataFormat)
        }

        if (type === 'url-clusterlet') {
            defaultNestedFields = createDefaultNestedFieldsForURLClusterlet(fieldDataFormat)
        }

        if (type === 'url-view') {
            defaultNestedFields = createDefaultNestedFieldsForURLView(fieldDataFormat)
        }

        if (type === 'chart-heatmap') {
            defaultNestedFields = createDefaultNestedFieldsForHeatmap(fieldDataFormat);
        }

        if (type === 'chart-rangeplot') {
            defaultNestedFields = createDefaultNestedFieldsForRangePlot(fieldDataFormat);
        }

        if (type === 'chart-stackbar') {
            defaultNestedFields = createDefaultNestedFieldsForStackBarChart(fieldDataFormat);
        }

        if (type === 'chart-ratiobar') {
            defaultNestedFields = createDefaultNestedFieldsForRatioBarChart(fieldDataFormat);
        }

        if (type === "gauge") {
            defaultNestedFields = createDefaultNesterFieldsForGauge()
        }

        // ! Need to check the commented code
        // if (parentType === 'chart-rangeplot') {
        //     defaultNestedFields = [
        //         {
        //             name: 'low',
        //             attributes: {
        //                 type: 'uint32',
        //                 desc: '',
        //                 unit: ''
        //             },
        //             type: 12,
        //             parent: [
        //                 {
        //                     type: 'field'
        //                 }
        //             ]
        //         },
        //         {
        //             name: 'high',
        //             attributes: {
        //                 type: 'uint32',
        //                 desc: '',
        //                 unit: ''
        //             },
        //             type: 12,
        //             parent: [
        //                 {
        //                     type: 'field'
        //                 }
        //             ]
        //         }
        //     ]
        // }

        if (type === 'model-3d') {
            defaultNestedFields = createDefaultNestedFieldsForModel3D(fieldDataFormat)
        }
        if (type === 'scene-3d') {
            defaultNestedFields = createDefaultNestedFieldsForScene3D(fieldDataFormat)
        }
        if (type === 'compass') {
            defaultNestedFields = createDefaultNestedFieldsForCompass(fieldDataFormat)
        }
        if (type === 'chart-pie-radial') {
            defaultNestedFields = createDefaultNestedFieldsForChartPieRadial(fieldDataFormat)
        }

        // hyperlink values
        if (hyperlink !== undefined && hyperlink === "enable") {
            if (hyperlinkType !== undefined && hyperlinkType === "urlView") {
                if (viewname !== undefined) fieldDataFormat.attributes.viewname = viewname
                if (instance !== undefined) fieldDataFormat.attributes.instance = instance
            }

            if (hyperlinkType !== undefined && hyperlinkType === "urlClusterlet") {
                if (clusterlettype !== undefined) fieldDataFormat.attributes.clusterlettype = clusterlettype
                if (instance !== undefined) fieldDataFormat.attributes.instance = instance
            }

            if (hyperlinkType !== undefined && hyperlinkType === "urlExternal") {
                if (data.url !== undefined) fieldDataFormat.attributes.url = data.url
            }
        }

        if (!dateStatus) {
            return false;
        }

        if (fieldDataFormat?.attributes?.default == null) delete fieldDataFormat.attributes.default;
        fieldDataFormat.children = defaultNestedFields;

        const payload = { field: fieldDataFormat, parentId: fieldDataFormat?.parent[0]?.id, parentType: fieldDataFormat?.parent[0]?.type, eventType: rootElement === "eventType" ? true : false }
        if(rootElement === "eventType"){
            payload.messageId = messageId
        }
        payload.rootParent = elementOnFocus.id;
        payload.rootParentType = elementOnFocus.type;

        dispatch(invokePostService('createField', payload)).then(res => {
            setLoading(false);
            if (res?.status) {
                dispatch(setInnerScreenRender());

                if (res?.data?.field?._id !== undefined) {
                    dispatch(setLatestFieldAdded([res?.data?.field?._id]));
                    dispatch(setExpanded(section.id))

                }

                if(isEventType) dispatch(setReRender());

                onCompletion('Field', 'add', [], undefined, res?.data?.field);
            } else {
                if (res?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                    res?.errors?.forEach(error => {
                        setError(error.name, { message: error.message });
                    });
                }
                if (res?.code === 255) {
                    onClose();
                }
            }
        });
    }


    const checkBrowserType = () => {
        return typeof navigator !== 'undefined' && navigator.userAgent.includes('Firefox');
    }
    const isFirefox = checkBrowserType();

    const messages = { ...validationMessages, ...patternOnlyMessage, ...requiredOnlyMessage, ...numberOnlyMessage, validate: 'This section name is already used' }

    return (

        <Grid container direction={"row"} spacing={3} style={isFirefox ? {paddingRight: '20px'} : null} >
            <Grid id={"create_field_form"} container direction={"row"} spacing={3} style={{ overflowY: 'scroll', float: 'left', transition: "height 10s ease-in-out"}}>

                <Grid item xs={12} style={{ "marginTop": 20 }}>
                    <Typography >Create new field</Typography>
                </Grid>

                {/* {rootElement === 'eventType' && <Grid item xs={12}>
                    <ReusedFieldWarning message={fieldParent} />
                </Grid>} */}

                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: isEventType ? '2fr 1fr' : '1fr',
                        padding: '0 12px',
                        gap: '12px',
                        width: '100%'
                    }}
                >
                    <Grid xs={12} item >
                        <TextField
                            name="name"
                            fullWidth
                            type={"text"}
                            required={true}
                            label={"Name"}
                            variant="outlined"
                            placeholder={"Name"}
                            inputRef={register({ ...variableBasic })}
                            error={errors?.name ? true : false}
                            helperText={errors?.name ? errors?.name?.message ? errors?.name?.message : messages[errors?.name?.type] : ''}
                        />
                    </Grid>
                    {renderOptionalValue && isEventType && <Grid item xs={12}>
                        <Controller
                            name="optional"
                            control={control}
                            render={({ field, onChange }) =>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            {...field}
                                            onChange={e => {
                                                onChange(e.target.checked)
                                                setOptional(e.target.checked)
                                            }}
                                            name="optional"
                                            id="optional"
                                            color="primary"
                                        />
                                    }
                                    label="Optional Field"
                                />
                            }
                        />
                    </Grid>
                    }
                </div>

                <Grid item xs={12}>
                    <TextField
                        id="description"
                        type={"text"}
                        fullWidth
                        rows={4}
                        label={"Description"}
                        placeholder={"Description"}
                        variant="outlined"
                        name="description"
                        inputRef={register({ required: false, validate: validateNonAsciiChars })}
                        error={errors?.description}
                        helperText={errors?.description?.message || ''}
                        multiline={true}
                        minRows={2}
                    />
                </Grid>


                {/* Types for clusterlet properties */}
                <Grid item xs={12}>
                    { !isEventType &&<Controller
                        name="type"
                        control={control}
                        rules={{ required: true, requiredOnly }}
                        render={({ field, onChange }) =>
                            <TextField
                                {...field}
                                name="type"
                                label={'Type'}
                                select
                                fullWidth
                                required
                                variant={'outlined'}
                                onChange={e => { onChange(e) }}
                                error={errors?.type ? true : false}
                                helperText={messages[errors?.type?.type] || ''}
                            >
                                <MenuItem key={123} value={""}>Select</MenuItem>


                                {(disableDisplayOptions && parentDT && (selectedNode?.type === 11 || selectedNode?.attributes?.type === "table")) && <ListSubheader disableSticky={true}>Display widgets</ListSubheader>}
                                {(disableDisplayOptions && parentDT && (selectedNode?.type === 11 || selectedNode?.attributes?.type === "table")) && displayTypes.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.title}
                                    </MenuItem>
                                ))}


                                {profile === false && <ListSubheader disableSticky={true}>Universal types</ListSubheader> }
                                {filteredTypeItems.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.title}
                                    </MenuItem>
                                ))}
                            </TextField>
                        }
                    />}
                    {isEventType &&
                      <Controller
                      name="type"
                      control={control}
                      rules={{ required: true }}
                      defaultValue={type}
                      render={({ field, value, onChange }) => {
                        const optionsWithSubheader = [
                          { title: 'Universal types', group: 'universalTypes', subheader: true, disabled: true, value: "#" },
                          ...filteredTypeItems,
                          { title: 'Messages', group: 'Messages', subheader: true, disabled: true, value: "#" },
                          ...messageTypes,
                        ];
                    
                        return (
                          <Autocomplete
                            {...field}
                            name="type"
                            options={optionsWithSubheader}
                            PopperComponent={CustomPopper}
                            className='MuiAutocomplete-popper'
                            classes={{root: "MuiAutocomplete-popper"}}
                            id='field-type-autocomplete'
                            getOptionLabel={(option) => (option.subheader ? '' : option.title || '')}
                            getOptionDisabled={(option) => option.disabled}
                            onChange={(event, newValue) => {
                              // Only allow actual items (not subheaders) to be selected
                              if (newValue && !newValue.subheader) {
                                onChange(newValue?.value || '');
                              }
                            }}
                            value={
                              optionsWithSubheader.find(option => option.value == value) || null
                            }
                            disableClearable={true}
                            noOptionsText="No matching types available"
                            renderOption={(option) => {
                              if (option.subheader) {
                                return <ListSubheader disableSticky={true} style={{padding: 0, margin: 0}}>{option.title}</ListSubheader>;
                              }
                    
                              return (
                                <MenuItem key={option.value} style={{padding: 0, margin: 0}} value={option.value}>
                                  {option.tooltip ? (
                                    <Tooltip title={option.tooltip} placement="right">
                                      <span>{option.title}</span>
                                    </Tooltip>
                                  ) : (
                                    <span>{option.title}</span>
                                  )}
                                </MenuItem>
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name="type"
                                label="Type"
                                variant="outlined"
                                required
                                error={Boolean(errors?.type)}
                                helperText={messages[errors?.type?.type] || ''}
                                fullWidth
                              />
                            )}
                          />
                        );
                      }}
                    />
                    }
                </Grid>

                {/* Chekcbox for allowing multiline values for String and OctectString type */}
                {renderMultilineInputCheckbox &&
                <Grid item xs={12} style={{marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0}}>
                    <Controller
                        name="allowMultiline"
                        control={control}
                        defaultValue={false} // optional: ensure initial value
                        render={({ field, onChange }) => (
                        <FormControlLabel
                            style={{ color: '#8f8f8f' }} // Light grey label
                            control={
                            <Checkbox
                                {...field}
                                onChange={(e) => {
                                    onChange(e.target.checked);
                                }}
                                name="allowMultiline"
                                id="allowMultiline"
                                color="default" // Use default color for more control
                                style={{ color: '#8f8f8f' }} // Light grey checkbox
                            />
                            }
                            label="Support Multiple Lines"
                        />
                        )}
                    />
                </Grid> }

                {/* icon type */}
                {renderIconType && <Grid item xs={12}>
                    <Controller
                        name="iconType"
                        control={control}
                        defaultValue={''}
                        render={({ field, value, onChange }) =>
                            <TextField
                                {...field}
                                name="iconType"
                                label={'Icon'}
                                select
                                fullWidth
                                variant={'outlined'}
                                value={value}
                                onChange={e => { onChange(e) }}
                            >
                                <MenuItem key={123} value={""}>Select</MenuItem>
                                {iconTypes.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.title}
                                    </MenuItem>
                                ))}
                            </TextField>
                        }
                    />
                </Grid>}

                {/* </Grid> */}
                {/* <Grid container direction={"row"} spacing={3} style={{ marginTop: 20, overflowY: 'scroll', float: 'left', transition: "height 0.1s", height: expandForm ? '100%' : '0px', }}> */}

                {renderdropdownValue && <Grid item xs={12}>
                    <TextField
                        id="dropdown"
                        type={"text"}
                        fullWidth
                        rows={4}
                        label={"Dropdown"}
                        placeholder={"Dropdown"}
                        variant="outlined"
                        name="dropdown"
                        inputRef={register({ required: false, })}
                        helperText={'Use comma seperated values for dropdown. Eg: "EEA:0, EEB:1"'}
                    />
                </Grid>}


                {renderCollectionValue && <Grid item xs={12}>
                    <Controller
                        name="collection"
                        control={control}
                        defaultValue={false}
                        render={({ field, value, onChange }) =>
                            <TextField
                                {...field}
                                name="collection"
                                label={'Collection'}
                                select
                                fullWidth
                                variant={'outlined'}
                                onChange={e => { onChange(e) }}
                                value={value}
                            >

                                {booleanOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.title}
                                    </MenuItem>
                                ))}
                            </TextField>
                        }
                    />
                </Grid>}


                {renderDefaultValue && <Grid item xs={12}>
                    <TextField
                        id="defaultVal"
                        type={"text"}
                        fullWidth
                        rows={4}
                        label={"Default"}
                        // defaultValue={defaultIntTypeValue}
                        placeholder={"Default"}
                        variant="outlined"
                        required={false}
                        name="defaultVal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputRef={register({ required: false, validate: typeSpecificValidation(type) })}
                        error={errors?.defaultVal ? true : false}
                        helperText={messages[errors?.defaultVal?.type] && numberTypes.includes(type) ? 'This field must be integer or float' :
                            messages[errors?.defaultVal?.type] ? 'This field must be integer/float/string' : ""}
                    />
                </Grid>}

                {renderDatePicker === true && <Grid item xs={12}>
                    <DateTimePickerField
                        id='defaultVal'
                        name='defaultVal'
                        label='Default date(UTC)'
                        defaultValue={null}
                        handleDatePicker={handleChange}
                        helperText={dateStatus ? 'Date is assumed to be UTC. Time will be assumed as 00:00:00' : 'Invalid date'}
                    />

                </Grid>}

                {renderBooleanDefaultValue && <Grid item xs={12}>
                    <Controller
                        name="defaultBoolVal"
                        control={control}
                        defaultValue={false}
                        render={({ field, value, onChange }) =>
                            <TextField
                                {...field}
                                name="defaultVal"
                                label={'Default'}
                                select
                                fullWidth
                                variant={'outlined'}
                                onChange={e => { onChange(e) }}
                                value={value}
                                defaultValue={false}
                            >

                                {booleanOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.title}
                                    </MenuItem>
                                ))}
                            </TextField>
                        }
                    />
                </Grid>}

                {renderMinValue && <Grid item xs={6}>
                    <TextField
                        id="minvalue"
                        type={"text"}
                        fullWidth
                        rows={4}
                        label={"Minimum Value"}
                        placeholder={"Minimum Value"}
                        variant="outlined"
                        name="minvalue"
                        inputRef={register({ required: false, validate: typeSpecificValidation(type) })}
                        error={errors?.minvalue ? true : false}
                        helperText={messages[errors?.minvalue?.type] && numberTypes.includes(type) ? 'This field must be integer or float' :
                            messages[errors?.minvalue?.type] ? 'This field must be integer/float/string' : ""}
                    />
                </Grid>}

                {renderMaxValue && <Grid item xs={6}>
                    <TextField
                        id="maxvalue"
                        type={"text"}
                        fullWidth
                        rows={4}
                        label={"Maximum Value"}
                        placeholder={"Maximum Value"}
                        variant="outlined"
                        name="maxvalue"
                        inputRef={register({ required: false, validate: typeSpecificValidation(type) })}
                        error={errors?.maxvalue ? true : false}
                        helperText={messages[errors?.maxvalue?.type] && numberTypes.includes(type) ? 'This field must be integer or float' :
                            messages[errors?.mixvalue?.type] ? 'This field must be integer/float/string' : ""}

                    />
                </Grid>}

                {renderUnitValue && <Grid item xs={12}>
                    <TextField
                        id="unit"
                        type={"text"}
                        fullWidth
                        rows={4}
                        label={"Unit"}
                        placeholder={"Unit"}
                        variant="outlined"
                        name="unit"
                        inputRef={register({ required: false, })}
                    />
                </Grid>}

                {renderaxisValue && <Grid item xs={12}>
                    <Controller
                        name="axis"
                        control={control}
                        render={({ field, onChange }) =>
                            <TextField
                                {...field}
                                name="axis"
                                label={'Axis'}
                                select
                                fullWidth
                                variant={'outlined'}
                                onChange={e => { onChange(e) }}
                            >
                                <MenuItem key={123} value={""}>Select</MenuItem>
                                {axisOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.title}
                                    </MenuItem>
                                ))}
                            </TextField>
                        }
                    />
                </Grid>}

                {/* dimensions split into height and width(hXw)  */}
                {(renderDisplayTypes || renderControlTypes) && <Grid item xs={6}>

                    <Controller
                        name="width"
                        control={control}
                        defaultValue={''}
                        render={({ field, value, onChange }) =>
                            <TextField
                                {...field}
                                name="width"
                                label={'Width'}
                                select
                                fullWidth
                                variant={'outlined'}
                                value={value}
                                onChange={e => { onChange(e) }}
                            >
                                <MenuItem key={123} value={""}>Select</MenuItem>
                                {fieldDimensionOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.title}
                                    </MenuItem>
                                ))}
                            </TextField>
                        }
                    />
                </Grid>}


                {(renderDisplayTypes || renderControlTypes) && <Grid item xs={6}>


                    <Controller
                        name="height"
                        control={control}
                        defaultValue={''}
                        render={({ field, value, onChange }) =>
                            <TextField
                                {...field}
                                name="height"
                                label={'Height'}
                                select
                                fullWidth
                                variant={'outlined'}
                                value={value}
                                onChange={e => { onChange(e) }}
                            >
                                <MenuItem key={123} value={""}>Select</MenuItem>
                                {fieldDimensionOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.title}
                                    </MenuItem>
                                ))}
                            </TextField>
                        }
                    />
                </Grid>}

                {renderOrientation && <Grid item xs={12}>
                    <Controller
                        name="orientation"
                        control={control}
                        render={({ field, onChange }) =>
                            <TextField
                                {...field}
                                name="orientation"
                                label={'Orientation'}
                                select
                                fullWidth
                                variant={'outlined'}
                                onChange={e => { onChange(e) }}
                            >
                                <MenuItem key={123} value={""}>Select</MenuItem>
                                {orientationOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.title}
                                    </MenuItem>
                                ))}
                            </TextField>
                        }
                    />
                </Grid>}

                {renderStep && <Grid item xs={12}>
                    <TextField
                        id="step"
                        type={"text"}
                        fullWidth
                        rows={4}
                        label={"Step"}
                        placeholder={"Step"}
                        variant="outlined"
                        name="step"
                        inputRef={register({ required: false, validate: integerFloatCheck })}
                        error={errors?.step ? true : false}
                        helperText={errors?.step ? 'This field must be integer or float' : ""}
                    />
                </Grid>}



                {renderValidationValue && <Grid item xs={12}>
                    <TextField
                        id="validation"
                        type={"text"}
                        fullWidth
                        rows={4}
                        label={"Validation"}
                        placeholder={"Validation"}
                        variant="outlined"
                        name="validation"
                        inputRef={register({ required: false, ...patternOnly })}
                        error={errors?.validation ? true : false}
                        helperText={messages[errors?.validation?.type] ? 'This field cannot contain special characters or white spaces' : ''}
                    />
                </Grid>}

                {renderlineType && <Grid item xs={12}>
                    <Controller
                        name="linetype"
                        control={control}
                        render={({ field, onChange }) =>
                            <TextField
                                {...field}
                                name="linetype"
                                label={'Line Type'}
                                select
                                fullWidth
                                variant={'outlined'}
                                onChange={e => { onChange(e) }}
                            >
                                <MenuItem key={123} value={""}>Select</MenuItem>
                                {lineTypeOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.title}
                                    </MenuItem>
                                ))}
                            </TextField>
                        }
                    />
                </Grid>}



                {rootElement === "property" && profile == false && <Grid item xs={12}>
                    <Controller
                        name="visible"
                        control={control}
                        defaultValue={selectedNode?.attributes?.type === 'table' ? true : ""}
                        render={({ field, value, onChange }) =>
                            <TextField
                                {...field}
                                name="visible"
                                label={'Visibility'}
                                select
                                fullWidth
                                variant={'outlined'}
                                value={value}
                                onChange={e => { onChange(e) }}
                            >
                                <MenuItem key={123} value={""}>Select</MenuItem>
                                {booleanOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.title}
                                    </MenuItem>
                                ))}
                            </TextField>
                        }
                    />
                </Grid>}


                {/* Enable or disable hyperlink */}
                {!profile && renderHyperlink && !isEventType && (
                    <Grid item xs={12}>
                        <Controller
                            name="hyperlink"
                            control={control}
                            defaultValue={'disable'}
                            render={({ field, onChange }) =>
                                <TextField
                                    {...field}
                                    name="hyperlink"
                                    label={'Hyperlink'}
                                    select
                                    fullWidth
                                    required
                                    variant={'outlined'}
                                    onChange={e => { onChange(e) }}
                                >
                                    {
                                        hyperlinkOptions.map(option =>
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.title}
                                            </MenuItem>
                                        )

                                    }
                                </TextField>
                            }
                        />
                    </Grid>
                )}

                {/* Hyperlink types */}
                {hyperlinkOption == "enable" && (
                    <Grid item xs={12}>
                        <Controller
                            name="hyperlinkType"
                            control={control}
                            rules={{ required: true, requiredOnly }}
                            render={({ field, onChange }) =>
                                <TextField
                                    {...field}
                                    name="hyperlinkType"
                                    label={'Hyperlink type'}
                                    select
                                    fullWidth
                                    required
                                    variant={'outlined'}
                                    onChange={e => { onChange(e) }}
                                    error={errors?.hyperlinkType ? true : false}
                                    helperText={errors?.hyperlinkType ? messages.required : ''}
                                >
                                    <MenuItem key={123} value={""}>Select</MenuItem>
                                    {
                                        hyperlinkTypes.map(option =>
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.title}
                                            </MenuItem>
                                        )

                                    }
                                </TextField>
                            }
                        />
                    </Grid>
                )}

                {/* View names list - Attribute for Url View */}
                {selectedHyperlinkType == "urlView" && (
                    <Grid item xs={12}>
                        <Controller
                            name="viewname"
                            control={control}
                            rules={{ required: true, requiredOnly }}
                            render={({ field, onChange }) =>
                                <TextField
                                    {...field}
                                    name="viewname"
                                    label={'View name'}
                                    select
                                    fullWidth
                                    required
                                    variant={'outlined'}
                                    onChange={e => { onChange(e) }}
                                    error={errors?.viewname ? true : false}
                                    helperText={errors?.viewname ? messages.required : ''}
                                >
                                    <MenuItem key={123} value={""}>Select</MenuItem>
                                    {
                                        viewsNames.map(view =>
                                            <MenuItem key={view._id} value={view._id}>
                                                {view.name}
                                            </MenuItem>
                                        )

                                    }
                                </TextField>
                            }
                        />
                    </Grid>
                )}

                {/* Clusterlet types list - Attribute for Url Clusterlet */}
                {selectedHyperlinkType == "urlClusterlet" && (
                    <Grid item xs={12}>
                        <Controller
                            name="clusterlettype"
                            control={control}
                            rules={{ required: true, requiredOnly }}
                            render={({ field, onChange }) =>
                                <TextField
                                    {...field}
                                    name="clusterlettype"
                                    label={'Clusterlet type'}
                                    select
                                    fullWidth
                                    required
                                    variant={'outlined'}
                                    onChange={e => { onChange(e) }}
                                    error={errors?.clusterlettype ? true : false}
                                    helperText={errors?.clusterlettype ? messages.required : ''}
                                >
                                    <MenuItem key={123} value={""}>Select</MenuItem>
                                    {
                                        clusterletNames.map(item =>
                                            <MenuItem key={item._id} value={item._id}>
                                                {item.name}
                                            </MenuItem>
                                        )

                                    }
                                </TextField>
                            }
                        />
                    </Grid>
                )}

                {renderControlTypes && type == "control-button" && < Grid item xs={12}>
                    <Controller
                        name="transaction"
                        control={control}
                        rules={{ required: true, requiredOnly }}
                        render={({ field, onChange }) =>
                            <TextField
                                {...field}
                                name="transaction"
                                label={'Transaction'}
                                select
                                fullWidth
                                required
                                variant={'outlined'}
                                onChange={e => { onChange(e) }}
                                error={errors?.transaction ? true : false}
                                helperText={messages[errors?.transaction?.type] || ''}
                            >
                                <MenuItem key={123} value={""}>Select</MenuItem>
                                {transactions.map((option) => (
                                    <MenuItem key={option._id} value={option._id}>
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        }
                    />
                </Grid>}


                {/* Instance */}
                {((renderControlTypes && type == "control-button") || (selectedHyperlinkType == "urlClusterlet" || selectedHyperlinkType == "urlView")) && (
                    <Grid xs={12} item >
                        <TextField
                            name="instance"
                            fullWidth
                            type={"text"}
                            required={true}
                            label={"Instance"}
                            variant="outlined"
                            placeholder={"Instance"}
                            inputRef={register({ ...basicFolderFileName })}
                            error={errors?.instance ? true : false}
                            helperText={errors?.instance ? messages["required"] : ""}
                        />
                    </Grid>
                )}


                {/* Url - Attribute for external url  */}
                {selectedHyperlinkType == "urlExternal" && (
                    <Grid xs={12} item >
                        <TextField
                            name="url"
                            fullWidth
                            type={"text"}
                            required={true}
                            label={"Url"}
                            variant="outlined"
                            placeholder={"Url"}
                            inputRef={register({ ...requiredOnly })}
                            error={errors?.url ? true : false}
                            helperText={errors?.url ? messages?.required : ''}
                        />
                    </Grid>
                )}


                {renderOptionalValue && !isEventType && <Grid item xs={12}>
                    <Controller
                        name="optional"
                        control={control}
                        render={({ field, onChange }) =>
                            <TextField
                                {...field}
                                name="optional"
                                label={'Optional'}
                                select
                                fullWidth
                                variant={'outlined'}
                                onChange={e => { onChange(e) }}
                            >
                                <MenuItem key={123} value={""}>Select</MenuItem>
                                {booleanOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.title}
                                    </MenuItem>
                                ))}
                            </TextField>
                        }
                    />
                </Grid>}

                {/* Constriants for message fields */}
                {renderContraint && <Grid item xs={12}>
                    <TextField
                        id="constraint"
                        type={"text"}
                        fullWidth
                        label={"Constraint"}
                        placeholder={"Constraint"}
                        variant="outlined"
                        name="constraint"
                        inputRef={register({ required: false })}
                        helperText={'Use comma seperated values for constraints or specify a range of values. Eg: "value1,value2" or "-10..10,20..30"'}
                    />
                </Grid>}

                {renderColorPicker && <>
                    <Grid item xs={6}>
                        <TextField
                            id="textColor"
                            label="Text Color"
                            type="text"
                            name="textColor"
                            value={textcolor}
                            onChange={(e) => setTextcolor(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                    <input
                                    type="color"
                                    value={textcolor}
                                    onChange={e => setTextcolor(e.target.value)}
                                    style={{cursor: 'pointer',width: '30px',height: '30px',border: 'none',padding: 0,background: 'none'}}
                                    />
                                </InputAdornment>
                                ),
                            }}
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6} style={{marginBottom: '10px'}}>
                        <TextField
                            id="backgroundColor"
                            label="Background Color"
                            name="backgroundColor"
                            type="text"
                            value={bgcolor}
                            onChange={(e) => setBgcolor(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                    <input
                                    type="color"
                                    value={bgcolor}
                                    onChange={e => setBgcolor(e.target.value)}
                                    style={{cursor: 'pointer',width: '30px',height: '30px',border: 'none',padding: 0,background: 'none'}}
                                    />
                                </InputAdornment>
                                ),
                            }}
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                </>}




            </Grid>

            {/* <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                <Link
                    href="#"
                    onClick={toggleExpandForm}
                >
                    {expandForm ? `Less configuration` : `More configuration`}
                    {expandForm ? <ExpandLessIcon fontSize='small' /> : <ExpandMoreIcon fontSize='small' />}
                </Link>
            </Grid> */}

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }}>
                <CreateCancel sticky createDisable={loading} content={loading ? 'Creating..' : 'Create'} onCreate={handleSubmit(onCreate)} onCancel={onClose} />
            </Grid>
        </Grid >


    )
}


function CustomPopper(props) {
    return <Popper {...props} id="type-autocomplete-popper" />;
  }